
import TrackerBase from './tracker-base.vue'
import {Column, TableHead} from 'components/data-table'

export default {
  components: {TrackerBase, Column, TableHead},
  props: {
    widget: {type: Object, required: true}
  },
}
